export const options = {
  chart: {
    height: 380,
    type: 'bar',
  },
  plotOptions: {
    bar: {
      colors: {
        ranges: [{
          from: -5,
          to: 0,
          color: '#ff5a5f'
        }, {
          from: 0,
          to: 5,
          color: '#2ecc71'
        }]
      },
      columnWidth: '80%',
    }
  },
  dataLabels: {
    enabled: false,
  },
  series: [{
    name: '',
    data: [-1, 1]
  }],
  title: {
    text: ''
  },
  yaxis: {
    labels: {
      formatter: function (val) {
        if (val == 1) {
          return 'Bien'
        }
        if (val == -1) {
          return 'Mal'
        }
        // return val
      }
    },
    tickAmount: 2,
    max: 1,
    min: -1
  },
  xaxis: {
    // TODO: uncomment below and fix the error
    //type: 'datetime',
    labels: {
      formatter: (val) => {
        let arr = val.split(" ")
        let dateArr = arr[0].split("/")
        let aux = ''
        switch (Number(dateArr[1])) {
          case 1:
            aux = `${dateArr[0]} Ene`;
            break;
          case 2:
            aux = `${dateArr[0]} Feb`;
            break;
          case 3:
            aux = `${dateArr[0]} Mar`;
            break;
          case 4:
            aux = `${dateArr[0]} Abr`;
            break;
          case 5:
            aux = `${dateArr[0]} May`;
            break;
          case 6:
            aux = `${dateArr[0]} Jun`;
            break;
          case 7:
            aux = `${dateArr[0]} Jul`;
            break;
          case 8:
            aux = `${dateArr[0]} Ago`;
            break;
          case 9:
            aux = `${dateArr[0]} Set`;
            break;
          case 10:
            aux = `${dateArr[0]} Oct`;
            break;
          case 11:
            aux = `${dateArr[0]} Nov`;
            break;
          case 12:
            aux = `${dateArr[0]} Dic`;
            break;
        }
        return aux
      }
    }
  },
  tooltip: {
    fixed: {
      enabled: true,
      position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
      offsetY: 30,
      offsetX: 60
    },
    y: {
      formatter: function (val) {
        if (val == 1) {
          return 'Bien'
        }
        if (val == -1) {
          return 'Mal'
        }
      }
    }
  }
}

export default options;



// WEBPACK FOOTER //
// ./src/helper/bar-chart-data.js